<template>
	<div>
		<h1 class="brief-title">科技领军人才创新创业基地（襄阳）简介</h1>
		<el-row type="flex" justify="space-around" align="middle" style="padding:20px;">
			<el-col :span="12">
				<div class="">
					<p>科技领军人才创新创业基地（襄阳）（以下简称“基地”）于2019年4月挂牌，2019年8月正式投入运营，是全国第4家、湖北省唯一的一家科技领军人才创新创业基地。基地由科学技术部人才交流开发服务中心宏观指导、襄阳市科技局统筹协调、襄阳高新区党工委建设管理，襄阳赋能众创空间孵化器有限公司运营实施。2022年10月，入选“湖北省中小企业公共服务严选服务机构”；2023年12月，入选“湖北省中小企业公共服务示范平台”；2024年1月，与武汉科技大学机械自动化学院共建“成果转化基地”。
					</p>
				</div>
			</el-col>
			<el-col :span="10">
				<el-image style="width: 100%;height:300px;" :src="require('../../static/base_4.jpg')"
					fit="cover"></el-image>
			</el-col>
		</el-row>
		<el-row type="flex" justify="space-around" align="middle" style="padding:20px;">
			<el-col :span="11">
				<el-image style="width: 100%;height:300px;" :src="require('../../static/base_8.jpg')"
					fit="cover"></el-image>
			</el-col>
			<el-col :span="11">
				<el-image style="width: 100%;height:300px;" :src="require('../../static/base_9.png')"
					fit="cover"></el-image>
			</el-col>
		</el-row>
		<!-- <el-row type="flex" justify="space-around" align="middle" style="padding:20px;background-color: #FFFFFF;">
			<el-col :span="10">
				<el-image style="width: 100%;height:280px;" :src="require('../../static/base_1.jpg')"
					fit="cover"></el-image>
			</el-col>
			<el-col :span="12">
				<el-divider content-position="left">
					<div class="name-group">
						<div class="name">运营机制</div>
						<div class="en_name">Operation mechanism</div>
					</div>
				</el-divider>
				<div class="remark">
					<p>科技领军人才创新创业基地（襄阳），由科学技术部科技人才交流开发服务中心指导、襄阳市科技局牵头推动建设、科技城管理办公室监督管理，襄阳赋能众创空间孵化器有限公司具体运营。</p>
					<p>科技领军人才创新创业基地（襄阳）坐落于襄阳科技城，于2019年4月举行启动仪式，2019年8月正式投入运营，专注于为高层次科技人才提供技术咨询、人才项目孵化、高新技术企业培育等专业服务，将科技人才资源与地方产业资源紧密结合，帮助科技人才发挥价值，助推人才项目快速落地发展，促进地方科技人才引进聚集，推动产业转型发展。
					</p>
				</div>
			</el-col>
		</el-row>
		<el-row align="middle" style="padding:20px;">
			<el-col :span="24" style="margin-bottom: 30px;">
				<el-divider content-position="left" class="no-background">
					<div class="name-group">
						<div class="name">服务内容</div>
						<div class="en_name">Service Content</div>
					</div>
				</el-divider>
			</el-col>
			<el-col :span="24">
				<el-row type="flex" justify="space-around" align="middle">
					<el-col :span="12">
						<div>
							<p>一是解决企业技术难题。围绕当地人才、企业的需求，对接科技领军人才开展一系列技术咨询、产业发展论坛、技术交易对接、成果转移转化等活动，实现高层次的人才智力资源与本地企业技术需求的精准对接，解决企业技术难题。
							</p>
							<p>二是人才引进培育。多种方式引进高层次人才创新创业，引进一批高端人才项目落地发展，培育一批科技领军人才。</p>
							<p>三是人才项目孵化。孵化一批创新能力强、产业带动力强的人才项目，培育一批高新技术企业。</p>
							<p>四是提供全方位创新创业服务。集聚高端创新创业要素资源，聚焦政策链、构建人才链、强化创新链、升级产业链，不断提升服务科技创新人才的能力，提高创新创业服务和资源融通的质量与效率，促进“人才—双创—产业”融合。
							</p>
							<p>五是优化双创生态。举办交流、对接、培训、联谊活动，促进圈层交流，推动产业链上下游对接、产业聚群聚集发展、大中小企业融通发展。</p>
						</div>
					</el-col>
					<el-col :span="10">
						<el-image style="width: 100%;height:100%;" :src="require('../../static/base_2.jpg')"
							fit="cover"></el-image>
					</el-col>
				</el-row>
			</el-col>
		</el-row> -->
		<el-row align="middle" style="padding:40px;">
			<el-col :span="24">
				<el-divider content-position="left" class="no-background">
					<div class="name-group">
						<div class="name">功能定位</div>
						<div class="en_name">Service Content</div>
					</div>
				</el-divider>
				<div class="remark">
					<p class="mar_bottom5">
						基地以搭建科技领军人才与襄阳企业的对接交流合作平台、打造国家科技领军人才创新创业服务中心为目标，以解决本地企业技术难题、引进集聚海内外科技领军人才、孵化培育人才创新项目、提供全要素创新创业服务为抓手，以响应襄阳市主导产业、主要产业链、重点企业的技术需求及人才需求为导向，核心业务有四大块：
					</p>
					<p style="font-weight: bold;">一是企业端，解决企业技术难题。</p>
					<p>服务内容包括征集企业技术需求，精准匹配专家开展技术咨询、邀请专家现场诊断、开展技术合作对接。
					</p>
					<p style="font-weight: bold;">二是高校端，解决高校院所科研成果落地转化“难题”。</p>
					<p class="mar_bottom5">
						服务内容包括高校专家教授成果对接与梳理、成果领域与襄阳中小企业产业领域的匹配、促成成果在各中小企业落地转化等。
					</p>
					<p style="font-weight: bold;">三是人才端，通过柔性或全职引进高端科技人才，解决政府和企业引才难题。</p>
					<p>包括人才需求征集、人才政策宣传、人才挖掘对接、“1+7”人才新政、车城人才等政策的宣传与落实等。
					</p>
					<p style="font-weight: bold;">四是项目端，引进孵化高端人才项目。</p>
					<p>引进与孵化、工商税务、办公场地、投融资、项目申报服务等全过程、全要素、全方位服务。
					</p>
				</div>
			</el-col>
		</el-row>
		<el-row align="middle" style="padding:40px;">
			<el-col :span="24">
				<el-divider content-position="left" class="no-background">
					<div class="name-group">
						<div class="name">工作成效</div>
						<div class="en_name">Service Content</div>
					</div>
				</el-divider>
				<div class="remark">
					<p style="font-weight: bold;">（一）以解决技术难题为牵引，促成科技成果在襄转化。</p>
					<p class="mar_bottom5">
						累计征集本地企业各类真实技术/人才需求500余项，精准匹配对接各类专家300余次，邀请60余位领军人才走进企业，促成专家教授与襄阳本地重点企业达成技术指导、合作开发或委托开发项目协议20多项，合同金额2000余万元。
					</p>
					<p style="font-weight: bold;">（二）以推进校地合作为契机，柔性或全职引进高端人才。</p>
					<p>与武汉科技大学机械与自动化学院合作建立襄阳成果转化基地，与武汉理工大学襄阳示范区开展专业学位硕士研究生培养示范点建设合作。聚焦院士、海智专家、国家和省级人才，以及博士、硕士以上学历的高端人才对接引进，柔性引才和全职引才实现叠加效应。2023年围绕高新区“汽车、新能源新材料、航空航天”3个重点产业绘制119人的产业人才地图，为高新区面向全国引才引智提供索引。
					</p>
					<p style="font-weight: bold;">（三）以争取资金为切口，积极引进孵化高端人才项目。</p>
					<p class="mar_bottom5">
						一是服务企业成长壮大，组织政策解读培训50余场，免费为企业提供政策咨询服务超3000人次，成功辅导15个创新创业团队获“省双创战略团队”资金支持，助力50余家中小企业成功认定高新技术企业，10余家企业成功申报省级专精特新中小企业和国家级专精特新“小巨人”，累计为孵化或服务企业争取政策扶持资金2000余万元。二是千方百计招引优质项目，利用招商网络中介平台，广泛捕捉产业动态信息，多措并举丰富项目资源“信息库”；通过各类才企对接活动，多方对接整合资源，主动对接经信、科技及招商等市级部门，推进牵线在谈项目落实落地。近2年洽谈对接高端项目40余家，引进落地高新区14家。
					</p>
					<p style="font-weight: bold;">（四）以产业研究为引擎，驱动襄阳现代化产业体系升级。</p>
					<p>依托国内外权威产业研究机构成果数据，结合襄阳产业发展实际，重点围绕汽车、绿色双碳、医药健康等细分赛道，挖掘整理“30个未来5年最具增长潜力的产业赛道”，并在2023年9月8日襄阳都市圈加快现代化产业体系建设高峰论坛公开发布，为企业开辟增长曲线、政府招商引资提供决策参考，得到市直部门、龙头支柱企业和行业产业专家的高度认可。
					</p>
					<p style="font-weight: bold;">（五）以强化人才服务为抓手，高标准打造基地服务品牌。</p>
					<p>一是紧盯成果转化强化基地内涵。市科技局依托基地工作成果申报的“重点产业科技人才需求诊断分析项目”，在23年市委组织部一把手（党委书记）抓人才工作综合考评活动中，位列全市70多个参考单位第三名的好成绩。二是对接关键资源完善服务体系。通过共享优质资源，集聚线下入驻机构30多家，线上合作机构228家，形成了“资源共享、优势互补、合作共赢”的科技服务体系。组织科技项目申报、资源对接、科经专员培训、技术合同登记、科技成果确权转化等各类服务，累计服务企业近千家、服务双创人才1000余名。三是提供配套服务提高项目落地效率。每年为100多个科技人才项目提供落地选址、执照代办、财税代理、人才代招、社保代缴等一站式、全流程配套服务，大幅提升了项目转化落地效率。
					</p>
				</div>
			</el-col>
			<el-col :span="24">
				<el-row type="flex" justify="space-between" style="margin-top: 20px;">
					<el-col :span="7">
						<el-image style="width: 100%;height: 100%;"
							:src="require('../../static/base_5.jpg')"></el-image>
					</el-col>
					<el-col :span="7">
						<el-image style="width: 100%;height: 100%;"
							:src="require('../../static/base_6.jpg')"></el-image>
					</el-col>
					<el-col :span="7">
						<el-image style="width: 100%;height: 100%;"
							:src="require('../../static/base_7.jpg')"></el-image>
					</el-col>
				</el-row>
			</el-col>
		</el-row>
		<el-row type="flex" justify="space-around" align="middle" style="padding:20px;background-color: #FFFFFF;">
			<el-col :span="10">
				<el-image style="width: 100%;height:300px;" :src="require('../../static/base_3.jpg')"
					fit="cover"></el-image>
			</el-col>
			<el-col :span="12">
				<el-divider content-position="left">
					<div class="name-group">
						<div class="name">发展规划</div>
						<div class="en_name">Development Planning</div>
					</div>
				</el-divider>
				<div class="remark">
					<p>基地将认真贯彻党的二十大和二十届三中全会精神，以及中央、省、市、区人才工作会议精神，致力于建成为自主创新的源发地、科技成果交易的集散地、科技成果转化的集中地、战略新兴产业的育成地，实现高端科技创新人才的高度聚集、科技成果的转移转化、高端人才创业项目的落地发展，成为地方经济发展新旧动能转换的新引擎，全力推动襄阳区域人才高地和创新中心建设成势见效。
					</p>
				</div>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	export default {
		name: 'training-base',
		data() {
			return {};
		},
		methods: {}
	};
</script>

<style lang="scss" scoped>
	.brief-title {
		text-align: center;
		font-size: 48px;
		letter-spacing: 5px;
		color: #4798dd;
		font-weight: bold;
		margin-bottom: 50px;
	}

	.name-group {
		display: flex;
		flex-direction: column;

		.name {
			font-size: 40px;
			color: #4798dd;
			font-weight: bold;
		}

		.en_name {
			line-height: 19px;
			font-size: 10px;
			color: #999999;
		}
	}

	.remark {
		margin-top: 50px;

	}

	p {
		text-indent: 30px;
		font-size: 16px;
		text-align: justify;
		line-height: 30px;
		color: #333333;
	}

	.no-background .el-divider__text {
		background-color: #F5F5F5;
	}

	.li_one {
		flex: 0 0 50%;
		flex-wrap: wrap;
		font-size: 16px;
		line-height: 36px;
		color: #666666;
		display: flex;
		align-items: center;

		.dot {
			width: 6px;
			height: 6px;
			border-radius: 3px;
			background-color: #0083cb;
		}
	}

	/*服务对象**/
	.objs {
		display: flex;
		flex-direction: row;
		justify-content: center;
		margin-top: 60px;
	}

	.obj {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		margin: 10px;
		width: 190px;
		height: 160px;
		border-radius: 95px;
		border: 1px solid #4798DD;

		.obj_img {
			width: 60px;
			height: 60px;
			background-repeat: no-repeat;
			background-position: center center;
			background-size: auto;
		}

		.obj_title {
			font-size: 17px;
			font-weight: bold;
			color: #4A99DD;
			text-align: center;
			margin-top: 18px;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/training-base.vue